// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import TextImageSvg from '@rsuite/icon-font/lib/file/TextImage';
var TextImage = createSvgIcon({
  as: TextImageSvg,
  ariaLabel: 'text image',
  category: 'file',
  displayName: 'TextImage'
});
export default TextImage;